import React from 'react';
import { Modal, Input, message } from 'antd';
import get from 'lodash/get';
import { deleteSharedTab } from '@store/sharedTabs';
import { useDispatch } from 'react-redux';
import combineDashboardName from '../utils/combineDashboardName';

const UpdateDashboardPopup = ({
  visible,
  toggleVisible,
  isFetching,
  hasError,
  id,
  tempId,
  title,
  dashboard,
  dashboardType,
  initCreating,
  initUpdating,
  createDashboard,
  updateDashboard,
}) => {
  const realId = tempId === -1 ? id : tempId;
  const isVisible = visible[realId];
  const inputRef = React.useRef(null);
  const dispatch = useDispatch();
  let formatTitle = title;
  if (id === -1) {
    formatTitle = combineDashboardName(title, dashboardType);
  }

  React.useEffect(() => {
    if (!isVisible) {
      initCreating();
      initUpdating();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  const handleOk = React.useCallback(
    () => {
      const dashboardName = get(inputRef, 'current.input.value');
      if (!dashboardName) {
        message.error('Please enter a legal dashboard name.');
        return;
      }
      if (id > 0) {
        updateDashboard(id, dashboardName, dashboard);
      } else {
        createDashboard(dashboardName, dashboard, dashboardType, tempId);
        dispatch(deleteSharedTab(tempId, false));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, dashboard, title, dashboardType],
  );

  const handleCancel = React.useCallback(
    () => {
      toggleVisible(false, id);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id],
  );

  return (
    <Modal
      title={id > 0 ? 'Update Dashboard' : 'Create Dashboard'}
      open={isVisible}
      onOk={handleOk}
      confirmLoading={!hasError && isFetching}
      onCancel={handleCancel}
      maskClosable={false}
      okText="Save"
    >
      <Input
        name="dashboard-name"
        placeholder="Enter dashboard name"
        defaultValue={formatTitle.replace(/\s/g, '').length === 0 ? '' : formatTitle}
        ref={inputRef}
        autocomplete="off"
      />
    </Modal>
  );
};

UpdateDashboardPopup.defaultProps = {
  tempId: -1,
};

export default UpdateDashboardPopup;
